export const BANNER_TYPES = {
  NEWS: "NEWS",
  PRODUCT: "PRODUCT",
  RESTAURANT: "RESTAURANT",
  VIDEO: "VIDEO",
};
